
// http://davidstutz.github.io/bootstrap-multiselect/
// https://github.com/davidstutz/bootstrap-multiselect
export function bootstrapMultiselect() {
	let I18N = {}

	let lastTitle = ''

	$('#form-question').on('mouseenter', '.multiselect-container a',function() {
		const $label = $(this).find('label')
		lastTitle = $label.attr('title')
		$label.attr('title', '')
	}).on('mouseleave', '.multiselect-container a',function() {
		$(this).find('label').attr('title', lastTitle)
	})

	function i18n(opt={}) {
		I18N = opt
	}

	function init(elm, opt={}) {
		const $elm = $(elm)
		if (!$elm.length) return

		const defaults = {
			includeSelectAllOption: true,
			numberDisplayed: 1,
			enableFiltering: true,
			templates: {
				filter: '<li class="multiselect-item filter"><input class="form-control multiselect-search" type="text"></li>'
			},
			enableCaseInsensitiveFiltering: true,
			maxHeight: 260,
			onInitialized: function($select, $container) {
				$container.find('label.checkbox').addClass('checkbox-custom').append('<span class="checkbox-custom-ico"></span>')
			}
		}

		const options = $.extend({}, defaults, I18N, opt)

		options.checkboxName = (option)=> options._checkboxNameStr

		$elm.multiselect(options);

		return $elm
	}

	return {
		i18n,
		init
	}
}

export function dropzone() {

	let DEFAULTS = {}

	function setup(opt) {
		DEFAULTS = $.extend({}, opt)
	}

	function init(dropzone, opt={}) {
		Dropzone.autoDiscover = false
		const droped = new Dropzone(dropzone, $.extend({}, DEFAULTS, opt))

		droped.on('error', function(file, msg) {
			let TPL = msg

			if (file.name) {
				TPL = `<span class="wo-b-ba">${file.name}</span><br>${TPL}`
			}

			spop({template: TPL, style: 'error' })

			droped.removeFile(file)
		});

		droped.on('sending', function(file, xhrObject, formData) {
			formData.append($_GP.CSRF_TOKEN, Cookies.get($_GP.CSRF_COOKIE))
		})

		return droped
	}

	return { setup, init }
}

/**
 *
 * @param {string} trigger $_GP.i18n.hashTriggers[trigger]
 * @param {funcion} callback
 * @requires $_GP.i18n.hashTriggers
 * @returns {undefined}
**/
export function hashTrigger(strTrigger, callback) {
	if (!$_GP.i18n || !$_GP.i18n.hashTriggers) {
		console.error('Missing object $_GP.i18n.hashTriggers')
		return
	}

	const trigger = $_GP.i18n.hashTriggers[strTrigger]
	if (!trigger || !trigger.hash) {
		console.error('Missing trigger hash in $_GP.i18n.hashTriggers[trigger]')
		return
	}

	const windowHash = window.location.hash
	if (!windowHash) return

	if (windowHash === $_GP.i18n.hashTriggers[strTrigger].hash) {
		if ('pushState' in history) {
			history.pushState('', document.title, window.location.pathname + window.location.search);
		}
		callback(trigger)
	}
}
